export enum SessionMode {
    InPerson = 0,
    Virtual = 1
}
